import { render } from "./BankRecReportCustom.vue?vue&type=template&id=21ff5740&scoped=true"
import script from "./BankRecReportCustom.vue?vue&type=script&lang=js"
export * from "./BankRecReportCustom.vue?vue&type=script&lang=js"

import "./BankRecReportCustom.vue?vue&type=style&index=0&id=21ff5740&scoped=true&lang=css"
import "./BankRecReportCustom.vue?vue&type=style&index=1&id=21ff5740&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ff5740"]])

export default __exports__